import type { SVGProps } from 'react';
const SvgIconInventory = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M6.5 7.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.5 7.75A.75.75 0 0 1 8.25 7h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M8.25 10a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 1a1.5 1.5 0 0 0-1.342.83L5.073 2H4.5A2.5 2.5 0 0 0 2 4.5v8A2.5 2.5 0 0 0 4.5 15h7a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 11.5 2h-.573l-.085-.17A1.5 1.5 0 0 0 9.5 1zm5 2.5A1.5 1.5 0 0 1 10 5H6a1.5 1.5 0 0 1-1.5-1.5 1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-5-1-.5 1h4l-.5-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconInventory;
